import type { EducationItem } from "components/Screens/Marketplace/Customer/types";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface EducationSectionProps {
  education: EducationItem[];
}

function EducationSection({ education }: EducationSectionProps) {
  if (!education || education.length === 0) {
    return null;
  }

  return (
    <div id="education" className="profile-content__section">
      <div className="profile-content__title mb-075">Education</div>
      <div className="education-timeline">
        {education.map((item, index) => (
          <div className={`education-item ${index === education.length - 1 ? "last" : ""}`}>
            <div className="education-item__date">{item.dateRange}</div>
            <div className="education-item__content">
              <div className="education-item__degree">{item.degree}</div>
              <div className="education-item__institution">{item.institution}</div>
              <div className="education-item__date--mobile">{item.dateRange}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EducationSection;
